import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyClosedLeadEmailMarketing() {
    return (
        <OnboardingBody title='What is email automation?'>
            <div>
                <p>
                    Connecting sales automation and your email marketing helps you stay in contact
                    with leads after they’re closed, so you can continue to nurture them.
                </p>
                <p>
                    You can add won leads to your customer newsletter, or put lost leads in a
                    winback campaign to change their minds.
                </p>
            </div>
        </OnboardingBody>
    );
}
